module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-from-to"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "date-from-to__datepicker-container"
  }, [_c('span', {
    staticClass: "date-from-to__datepicker-seperator"
  }, [_c('datepicker', {
    attrs: {
      "lang": "eng",
      "value": _vm.value.from,
      "not-before": _vm.fromNotBeforeDate,
      "not-after": _vm.fromEndDate,
      "disabled": _vm.disableFrom || _vm.disableTo,
      "clear": function (e) { return _vm.changeFrom(null); },
      "input-class": "mx-input date-from-to__datepicker-input"
    },
    on: {
      "input": _vm.changeFrom
    }
  })], 1), _vm._v(" "), _c('span', [_c('datepicker', {
    attrs: {
      "lang": "eng",
      "value": _vm.value.to,
      "disabled": !_vm.enableTo,
      "not-before": _vm.toStartDate,
      "clear": function (e) { return _vm.changeTo(null); },
      "input-class": "mx-input date-from-to__datepicker-input"
    },
    on: {
      "input": _vm.changeTo
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2f5569e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/dateRange/DateFromTo.vue
// module id = 2001
// module chunks = 0